import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import App from './App.vue'

import dayjs from 'dayjs'
import VueNumberFormat from '@igortrindade/vue-number-format'

const routes = [
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

const app = createApp(App)

app.provide('dayjs', dayjs)
app.use(router)
app.use(VueNumberFormat, { prefix: '', thousand: '', decimal: ',', precision: 0, suffix: '' })
app.mount('#app')
